import addPanelDataConsts from '@/addPanelDataConsts';
import bookingsWelcome from './bookingsWelcome';

const bookingsWelcomeSection = {
  type: addPanelDataConsts.SECTIONS_TYPES.GENERAL,
  hide: false,
  title: 'add_section_label_bookings_welcome',
  showSectionHeader: true,
  props: {
    class: 'no-space-before-section invisible-header',
    template: bookingsWelcome,
  },
  help: {
    hide: false,
    text: 'add_section_label_bookings_welcome_tooltip_description',
  },
};

export default {
  getCategorySections() {
    return {
      bookingsWelcomeSection,
    };
  },
};
